import { Box } from "@mui/material";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

import { Loader } from "@/atoms";
import { PageHead, ReleaseMotionArtworkForm } from "@/components";

const ReleaseMotionArtworksTab = ({ data }) => {
    const { t } = useTranslation();

    const formValues = { motionArtworks: data?.data };

    return data?.loading ? (
        <Loader />
    ) : (
        <Box>
            <PageHead title={t("tabs.motionArtworks")} />
            <ReleaseMotionArtworkForm values={formValues} />
        </Box>
    );
};

export default ReleaseMotionArtworksTab;

ReleaseMotionArtworksTab.propTypes = { data: PropTypes.object };
